import {
  FETCH_LOADDATA_INIT,
  FETCH_LOADDATA_SUCCESS,
  FETCH_LOADDATA_FAIL,
  FETCH_LOADDATABYID_SUCCESS,
  FETCH_CARGOTYPE_SUCCESS,
  FETCH_RUNNERS_SUCCESS,
  FETCH_CARGOSIZE_SUCCESS,
  FETCH_LOADMATRIX_SUCCESS,
  GETVEHICLE_SUCCESS,
  GET_DISTANCE_SUCCESS,
  GET_RATECARD_SUCCESS,
  GET_PAYMODE_SUCCESS,
  GET_TOTALVEHICLE_SUCCESS,
  GET_SUBSCRIPTION_SUCCESS,
  GET_BID_DATA_BY_ID_ACTION_SUCCESS,
  GET_SPECIFICRUNNER_SUCCESS,
  GET_NEAREST_RUNNERS_SUCCESS,
  GET_SPECIFIC_CARGO_SUCCESS,
  FETCH_CURRENCY_SUCCESS,
  FETCH_SUB_FORRUNNER_SUCCESS,
  FETCH_PAYCANCELLATION_SUCCESS,
  FETCH_RUNNERVEHICLES_SUCCESS,
} from "./action";

const initialState = {
  processing: false,
  error: false,
  docAdd: [],
  rateCard: [],
  bidData: [],
  subscriptionStatus: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_LOADDATA_INIT:
      return {
        ...state,
        processing: true,
      };

    case FETCH_LOADDATA_SUCCESS:
      return {
        ...state,
        processing: false,
        loadList: action.payload.rows,
        loadCount: action.payload.count,
      };

    case FETCH_LOADDATA_FAIL:
      return {
        ...state,
        processing: false,
      };

    case FETCH_LOADDATABYID_SUCCESS:
      return {
        ...state,
        loadById: action.payload,
      };

    case FETCH_CARGOTYPE_SUCCESS:
      return {
        ...state,
        cargoType: action.payload.rows,
      };

    case FETCH_RUNNERS_SUCCESS:
      return {
        ...state,
        avlbleRunners: action.payload.rows,
      };

    case FETCH_CARGOSIZE_SUCCESS:
      return {
        ...state,
        avlbleCargoSize: action.payload.rows,
      };

    case FETCH_LOADMATRIX_SUCCESS:
      return {
        ...state,
        loadMatrix: action.payload.rows,
      };

    case GETVEHICLE_SUCCESS:
      console.log(action.payload);
      return {
        ...state,
        vehiclewithDup: action.originalpayload,
        vehicleType: [
          action.payload.map((item, i) => {
            return item.subCatgry.id;
          }),
        ],
        vehicleTypetoDB: [
          action.payload.map((item, i) => {
            return {
              vehicleId: item.subCatgry.id,
              name: item.subCatgry.name,
              noOfUnits: item.noOfUnits,
            };
          }),
        ],
      };

    case GET_DISTANCE_SUCCESS:
      return {
        ...state,
        estDistance: action.payload.data.estDist,
      };
    case GET_RATECARD_SUCCESS:
      return {
        ...state,
        rateCard: action.payload,
      };

    case GET_PAYMODE_SUCCESS:
      return {
        ...state,
        payMode: action.payload.rows.filter(
          (i) => i.name !== "subscription" && i.name !== "bid"
        ),
        actualPayMode: action.payload.rows,
        bidPayMode: action.payload.rows.filter((i) => i.name === "bid"),
        subscriptionPayMode: action.payload.rows.filter(
          (i) => i.name === "subscription"
        ),
        bankPayMode: action.payload.rows.filter(
          (i) => i.name === "bank transfer"
        ),
        codPayMode: action.payload.rows.filter(
          (i) => i.name === "cash on delivery"
        ),
      };

    case GET_TOTALVEHICLE_SUCCESS:
      return {
        ...state,
        totalVehicles: action.payload.rows,
      };

    case GET_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        subscriptionStatus: action.payload.rows,
      };
    case GET_BID_DATA_BY_ID_ACTION_SUCCESS:
      console.log(action.payload.rows);
      return {
        ...state,
        bidData: action.payload.rows,
        biddedData: action.payload.rows[0],
      };

    case GET_SPECIFICRUNNER_SUCCESS:
      return {
        ...state,
        runner: action.payload,
      };

    case GET_NEAREST_RUNNERS_SUCCESS:
      console.log(action.payload);
      return {
        ...state,
        runnersnearpickup: action.payload,
        runnerArrays: action.tempPayload,
      };

    case GET_SPECIFIC_CARGO_SUCCESS:
      return {
        ...state,
        cargo: action.payload,
      };

    case FETCH_CURRENCY_SUCCESS:
      return {
        ...state,
        currencyList: action.payload.rows,
      };

    case FETCH_SUB_FORRUNNER_SUCCESS:
      return {
        ...state,
        subForRunner: action.payload.rows,
      };

    case FETCH_PAYCANCELLATION_SUCCESS:
      return {
        ...state,
        cancellationDetails: action.payload.rows,
      };

    case FETCH_RUNNERVEHICLES_SUCCESS:
      return {
        ...state,
        fetchedVehicleofRunner: action.payload.rows,
      };

    default:
      return {
        ...state,
      };
  }
}
